import AxiosPermisos from "@/services/axiosPermisos";

import { paths } from "./path";

import { map_query } from "@/core/functions/map-path-query";

async function getLaborUnions() {
  return await AxiosPermisos.get(paths.laborUnions, true, "v2");
}

async function getLaborUnionsEmployee(id = 0, data = {}) {
  const url = paths.laborUnions.concat(
    `/${id}/employees`.concat(map_query(data))
  );
  return await AxiosPermisos.get(url, true, "v2");
}
async function getLaborUnionGraphicData(dataGraphic) {
  const url = paths.laborUnionGraphicData.concat(map_query(dataGraphic));
  return await AxiosPermisos.get(url, true, "v2");
}
async function getUnionWorkerInformation(dataWorker) {
  const url = paths.laborUnionWorkerInformation.concat(map_query(dataWorker));
  return await AxiosPermisos.get(url, true, "v2");
}

async function getDownloadReportService(data = {}) {
  const url = paths.laborUnionDownloadReport.concat(map_query(data));
  return await AxiosPermisos.get(url, true, "v2");
}

async function getLaborUnionSocieties(id = 0) {
  const url = paths.laborUnions.concat(`/${id}/societies`);
  return await AxiosPermisos.get(url, true, "v2");
}

async function getPeriodConventional(societyId, laborUnionId) {
  return await AxiosPermisos.get(
    `${paths.periodConventionals}/${societyId}/${laborUnionId}`,
    true,
    "v2"
  );
}

async function getStatisticsPayments(data = {}) {
  return await AxiosPermisos.get(
    `${paths.statisticsPayments}`,
    true,
    "v2",
    data,
  );
}

async function getLaborUnionSocietyConventionalPeriodService(
  unionId = 0,
  society = 0,
  conventionalAgreement = false,
  data = {}
) {
  const url =
    conventionalAgreement && society > 0 && society
      ? paths.laborUnions.concat(
          `/${unionId}/societies/${society}/information`.concat(map_query(data))
        )
      : paths.laborUnions.concat(
          `/${unionId}/information`.concat(map_query(data))
        );

  return await AxiosPermisos.get(url, true, "v2");
}

export {
  getLaborUnions,
  getLaborUnionsEmployee,
  getLaborUnionGraphicData,
  getUnionWorkerInformation,
  getDownloadReportService,
  getLaborUnionSocieties,
  getLaborUnionSocietyConventionalPeriodService,
  getPeriodConventional,
  getStatisticsPayments,
};
